import "./maintenance.css";
const Maintenance = () => {
  return (
    <>
      <div className="outer">
        <div class="browser-frame ">
          {/* <div class="browser-dots">
            <span class="dot red"></span>
            <span class="dot yellow"></span>
            <span class="dot green"></span>
          </div> */}

          <div class="content">
            <div class="text-content">
              <h1>
                We're taking timeout for{" "}
                <span class="highlight">maintenance</span>
              </h1>

              <p class="description">
                We'll be back in a few hours. Thanks for your patience while we
                make things better!
              </p>

              <div class="status-list">
                <div class="status-item completed">
                  <span class="status-icon">✓</span>
                  Database optimization in progress
                </div>
                <div class="status-item completed">
                  <span class="status-icon">✓</span>
                  Security updates being applied
                </div>
                <div class="status-item in-progress">
                  <span class="status-icon">⏱</span>
                  Performance improvements underway
                </div>
              </div>

              <div class="contact">
                <h3>Need immediate help?</h3>
                <a href="mailto:info@techniajz.com" class="email">
                  info@techniajz.com
                </a>
                {/* <div class="phone-placeholder"></div> */}
              </div>
            </div>
            <div class="img">
                <img src="https://img.freepik.com/free-vector/computer-service-abstract-concept-illustration_335657-1897.jpg?ga=GA1.1.1579373256.1749465920&semt=ais_hybrid&w=740"></img>
            </div>
          </div>
        </div>
      </div>
    </>
  ); 
};

export default Maintenance;
